<div class="edp-card-widget card desktop">
    <div class="card-header">
        <span class="card-title">{{ 'pt.edp.edponline.payment.title' | translate }}</span>
        <span class="card-icon">
            <i class="icon-edponline-EDP_Online_payment"  aria-hidden="true"></i>
        </span>
    </div>
    <div class="card-body">
        <!-- SECÇÃO 1 -->
        <span class="value" [innerHTML]="value | edpDecimalSplit"></span>
        <!-- SECÇÃO 2 -->
        <span class="title">{{ 'pt.edp.edponline.payment.period.title' | translate }}</span>
        <div class="period d-flex">
            <div class="my-auto">
                <span class="date">
                    {{ dateFrom |  date: 'd MMM y'}}
                    {{ 'pt.edp.edponline.payment.date' | translate }}
                    {{ dateTo |  date: 'd MMM y'}}
                </span>
            </div>
            <div class="my-auto ml-auto">
                <a [routerLink]="link">
                <span class="more">{{ 'pt.edp.edponline.payment.period.see.detail' | translate }}</span>
                    <span class="d-inline-block align-middle mx-2">
                        <i class="icon-edponline-Bop-073 rotate-270 icon"  aria-hidden="true"></i>
                    </span>
                </a>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <span class="conta-certa" *ngIf="contract?.HasContaCerta">7{{ 'pt.edp.edponline.payment.conta.certa' | translate }}</span>
        <div class="d-flex my-2">
            <div>
                <span class="title-content first">{{ 'pt.edp.edponline.payment.direct.debit.title' | translate }}</span>
                <span class="detail-content"><b>{{ dateLimit |  date: 'd MMM y'}}</b></span>
            </div>

            <div class="ml-auto banco" *ngIf="contract?.BankName">
                <span class="title-content">{{ 'pt.edp.edponline.payment.bank.title' | translate }}</span>
                <span class="detail-content">{{ contract?.BankName | truncate: 24 }}</span>
            </div>
        </div>
        <div>
            <span class="title-content">{{ 'pt.edp.edponline.payment.iban.title' | translate }}</span>
            <span class="detail-content-mobile">{{ contract?.DirectDebitIban }}</span>
        </div>
    </div>
</div>

<div class="edp-card-widget card d-lg-none mobile">
  <div class="card-header">
    <span class="card-title">{{ 'pt.edp.edponline.payment.title' | translate }}</span>
    <span class="card-icon">
      <i class="icon-edponline-EDP_Online_payment"  aria-hidden="true"></i>
    </span>
  </div>
  <div class="card-body mobile">
    <!-- SECÇÃO 1 -->
    <span class="value" [innerHTML]="value | edpDecimalSplit"></span>
    <!-- SECÇÃO 2 -->
    <span class="title">{{ 'pt.edp.edponline.payment.period.title' | translate }}</span>
    <div class="period d-flex">
        <div class="my-auto">
            <span class="date">
                {{ dateFrom |  date: 'd MMM y'}}
                {{ 'pt.edp.edponline.payment.date' | translate }}
                {{ dateTo |  date: 'd MMM y'}}
            </span>
        </div>
        <div class="my-auto ml-auto">
            <a [routerLink]="link">
            <span class="more">{{ 'pt.edp.edponline.payment.period.see.detail' | translate }}</span>
                <span class="d-inline-block align-middle mx-2">
                    <i class="icon-edponline-Bop-073 rotate-270 icon"  aria-hidden="true"></i>
                </span>
            </a>
        </div>
    </div>
</div>
  <div class="card-footer">
    <span class="conta-certa" *ngIf="contract?.HasContaCerta">7{{ 'pt.edp.edponline.payment.conta.certa' | translate }}</span>
        <div class="d-flex my-2">
            <div>
                <span class="title-content first">{{ 'pt.edp.edponline.payment.direct.debit.title.mobile' | translate }}</span>
                <span class="detail-content-mobile"><b>{{ dateLimit |  date: 'd MMM y'}}</b></span>
            </div>

            <div class="ml-auto banco" *ngIf="contract?.BankName">
                <span class="title-content">{{ 'pt.edp.edponline.payment.bank.title' | translate }}</span>
                <span class="detail-content-mobile">{{ contract?.BankName | truncate: 25 }}</span>
            </div>
        </div>
  </div>
</div>